/**
 * True if the current environment is using MacOS keyboard shortcuts.
 */
const WITH_MACOS_KEYBOARD_SHORTCUTS =
    typeof navigator !== 'undefined' &&
    // navigator.platform is deprecated
    ((typeof navigator.platform === 'string' &&
        Boolean(navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i))) ||
        (typeof navigator.userAgent === 'string' && navigator.userAgent.includes('Mac OS X')));

/*
 * Shortcuts in the application
 */
export const SEARCH_OPEN = modShortcut('mod+k');
// Binding only ? doesn't work
export const HELP = '?,shift+?,shift+/';
export const TOGGLE_SIDEBAR = modShortcut('mod+shift+\\');
/**
 * Start editing current space using a change request
 */
export const EDIT_SPACE_CR = modShortcut('mod+shift+e');
/**
 * Submit the change request for review
 */
export const SUBMIT_SPACE_CR = modShortcut('mod+shift+s');
/**
 * Close the details panel of an audit event
 */
export const CLOSE_AUDIT_EVENT_DETAILS = 'esc';

/*
 * Shortcuts in the editor.
 */
export const EDITOR_SAVE = modShortcut('mod+s');
export const EDITOR_PALETTE = modShortcut('/');
export const EDITOR_MODIFIER_PALETTE = modShortcut('mod+/');
export const EDITOR_BOLD = modShortcut('mod+b');
export const EDITOR_ITALIC = modShortcut('mod+i');
export const EDITOR_STRIKETHROUGH = modShortcut('mod+shift+s');
export const EDITOR_COMMENT = modShortcut('mod+shift+m');
export const EDITOR_AI = modShortcut('mod+j');
export const EDITOR_SUPERSCRIPT = modShortcut('mod+.');
export const EDITOR_SUBSCRIPT = modShortcut('mod+,');
export const EDITOR_RESIZE_COVER = '↑+↓';

// Copy the change request title
export const COPY_CHANGE_REQUEST_TITLE = modShortcut('mod+c');

/*
 * Shortcuts in specific blocks.
 */
export const TABLE_INSERT_ROW_ABOVE = modShortcut('alt+enter');
export const TABLE_INSERT_ROW_BELOW = modShortcut('alt+shift+enter');
export const TABLE_MOVE_DOWN = modShortcut('enter');
export const TABLE_MOVE_UP = modShortcut('shift+enter');
export const TABLE_ROW_DELETE = modShortcut('mod+-');
export const TABLE_SELECTION_OPTIONS = modShortcut('mod+shift+/');
export const TABLE_RESIZE_COL = '←+→';

// On MacOS, Ctrl+E is used to go to the end of the line
// https://www.amsys.co.uk/useful-mac-text-editing-shortcuts/
export const EDITOR_CODE = modShortcut('mod+e');
export const EDITOR_LINK = modShortcut('mod+k');
export const EDITOR_ANNOTATION = modShortcut('mod+alt+f');

// shortcuts that aren't bound directly but are used by Slate
export const EDITOR_UNDO = modShortcut('mod+z');
export const EDITOR_REDO = ['mod+shift+z', 'mod+y'].map(modShortcut).join(',');
export const EDITOR_EXIT_BLOCK = modShortcut('mod+enter');

/** Prepare a shortcut for the OS, depending on a common pattern */
function modShortcut(shortcut: string): string {
    return shortcut.replace('mod', WITH_MACOS_KEYBOARD_SHORTCUTS ? 'command' : 'ctrl');
}
